// eslint-disable-next-line
import React, { useState, useEffect } from 'react';
import { Luminary } from '../../types/luminary';
import { ACTION_TYPE_COPY, ACTION_TYPE_NONE } from '../../constants';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { AssetListItem } from '../../components/AssetListItem/AssetListItem';
import { DEVICE_TYPE } from '../enum/ENUM';

type Props = {
    luminary: Luminary;
    deviceType?: string;
};

export const LuminaryInfo: React.FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props: Props) => {
    const { t } = useLanguageLocale();
    const [luminary, setLuminary] = useState<Luminary>(props.luminary);

    useEffect(() => {
        setLuminary(props.luminary);
    }, [props.luminary]);

    function copyToClipboard(valueToCopy: string) {
        const tempInput = document.createElement('input')
        tempInput.value = valueToCopy
        document.body.appendChild(tempInput)
        tempInput.select()
        document.execCommand('copy')
        document.body.removeChild(tempInput)
    }

    return (
        <div style={{ flex: '1 1 0px', overflow: 'auto' }} data-testid="device-luminary-details-info-container">

            <AssetListItem
                data-testid='luminary-info-description'
                key={'luminary-info-description'}
                subtitle={luminary.luminaryDescription ?? '--'}
                title={t('LUMINARY_DETAILS.LUMINAIRE_DESCRIPTION')}
                imageType={ACTION_TYPE_NONE}
                divider={false}
                titleBold={false}
            ></AssetListItem>

            {
                props.deviceType !== DEVICE_TYPE.DEVICE_TYPE_CGLINE &&
                <AssetListItem
                    data-testid='luminary-info-type'
                    key={'luminary-info-type'}
                    subtitle={luminary.type ? luminary.type : '--'}
                    title={t('DEVICE_DETAILS.TYPE')}
                    imageType={ACTION_TYPE_NONE}
                    divider={false}
                    titleBold={false}
                ></AssetListItem>
            }

            {
                props.deviceType !== DEVICE_TYPE.DEVICE_TYPE_CGLINE &&
                <AssetListItem
                    data-testid='luminary-info-model'
                    key={'luminary-info-model'}
                    subtitle={luminary.luminaryPartNumber ? luminary.luminaryPartNumber : '--'}
                    title={t('DEVICE_DETAILS.LUMINARY_MODEL')}
                    imageType={ACTION_TYPE_COPY}
                    OnItemSelected={(): void =>
                        copyToClipboard(luminary.luminaryPartNumber ? luminary.luminaryPartNumber : '')
                    }
                    divider={false}
                    titleBold={false}
                ></AssetListItem>
            }

            <AssetListItem
                data-testid='luminary-info-atsd'
                key={'luminary-info-atsd'}
                subtitle={(props.deviceType === DEVICE_TYPE.DEVICE_TYPE_CGLINE ? luminary.line : '' + luminary.ATSD) ?? '--'}
                title={props.deviceType === DEVICE_TYPE.DEVICE_TYPE_CGLINE
                    ? t('DEVICE_DETAILS.LUMINARY_LINE')
                    : t('DEVICE_DETAILS.LUMINARY_ATSD')}
                imageType={ACTION_TYPE_NONE}
                divider={false}
                titleBold={false}
            ></AssetListItem>

            <AssetListItem
                data-testid='luminary-info-circuit'
                key={'luminary-info-circuit'}
                subtitle={([DEVICE_TYPE.DEVICE_TYPE_CGLINE, DEVICE_TYPE.DEVICE_TYPE_WIRELESS].includes(props.deviceType as DEVICE_TYPE) ? luminary.zone : luminary.circuit) ?? '--'}
                title={
                    [DEVICE_TYPE.DEVICE_TYPE_CGLINE, DEVICE_TYPE.DEVICE_TYPE_WIRELESS].includes(props.deviceType as DEVICE_TYPE)
                        ? t('DEVICE_DETAILS.LUMINARY_ZONE')
                        : t('DEVICE_DETAILS.LUMINARY_CIRCUIT_HASH')
                }
                imageType={ACTION_TYPE_NONE}
                divider={false}
                titleBold={false}
            ></AssetListItem>

            <AssetListItem
                data-testid='luminary-info-address'
                key={'luminary-info-address'}
                subtitle={luminary.shortAddress ?? '--'}
                title={t('DEVICE_DETAILS.LUMINARY_ADDRESS')}
                imageType={ACTION_TYPE_NONE}
                divider={false}
                titleBold={false}
            ></AssetListItem>

            {
                props.deviceType !== DEVICE_TYPE.DEVICE_TYPE_CGLINE &&
                <AssetListItem
                    data-testid='luminary-info-serial_number'
                    key={'luminary-info-serial_number'}
                    subtitle={luminary.luminaryEPAS ? luminary.luminaryEPAS : '--'}
                    title={t('DEVICE_DETAILS.SERIAL_NUMBER')}
                    imageType={ACTION_TYPE_COPY}
                    OnItemSelected={(): void =>
                        copyToClipboard(luminary.luminaryEPAS ? luminary.luminaryEPAS : '')
                    }
                    divider={false}
                    titleBold={false}
                ></AssetListItem>
            }

            {
                props.deviceType === DEVICE_TYPE.DEVICE_TYPE_CGLINE &&
                <AssetListItem
                    data-testid='luminary-info-CGLineId'
                    key={'luminary-info-CGLineId'}
                    subtitle={luminary.longAddress ?? '--'}
                    title={t('LUMINARY_DETAILS.CG_LINE_PLUS_ID')}
                    imageType={ACTION_TYPE_NONE}
                    divider={false}
                    titleBold={false}
                ></AssetListItem>
            }

        </div>
    );
};